var map = {
	"./appstore.png": 2630,
	"./eldIcon.jpg": 2631,
	"./googleplay.png": 2632,
	"./logedIcon.png": 2633,
	"./logo_mobile.png": 2634,
	"./onBoarding.webp": 2635,
	"./smallLogo.png": 2636,
	"./spotlightGreen.png": 2637,
	"./spotlightGrey.png": 2638,
	"./spotlightRed.png": 2639
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3812;